const translationsRU = {
  today: 'Сегодня',
  yesterday: 'Вчера',
  lessThanFiveDaysAgo: 'дня назад',
  daysAgo: 'дней назад',
};

export default translationsRU;
